import Plugin from 'src/plugin-system/plugin.class';
import algoliasearch from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';

export default class SearchPlugin extends Plugin {

    init() {

        const searchClient = algoliasearch(
            'VVXGFMW7LQ',
            '639e0116c087ca9e0e575f2515329dd3'
        );

        var that = this;
        var options = {
          container: '#autocomplete',
          detachedMediaQuery: 'none',
          placeholder: that.options.placeholder,
          getSources({ query }) {
            return [
              {
                sourceId: 'products',
                getItems() {
                  return getAlgoliaResults({
                    searchClient,
                    queries: [
                      {
                        indexName: 'wp_searchable_posts',
                        query,
                        params: {
                          hitsPerPage: 5,
                          attributesToSnippet: ['name:10', 'description:35'],
                          snippetEllipsisText: '…',
                        },
                      },
                    ],
                  });
                },
                getItemUrl({ item }) {
                  return item.permalink;
                },
                
                templates: {
                  header() {
                      return that.options.header;
                  },
                  item({ item, createElement }) {
                      return <a href={item.permalink}>{item.post_title}</a>;
                  },
                },
              },
            ];
          },
          onSubmit: function(event) {

            if (!event.state.query) {
              return;
            }

            window.location.href = that.options.search_url.replace('term', event.state.query);

          }
        };

        var elements = ['#autocomplete', '#autocomplete-mobile'];

        elements.forEach((element) => {
          options.container = element;
          autocomplete(options);
        });
        
    }

}
